import React, { useState, useEffect, useRef, useContext } from "react";
import { Form, Row, Modal } from "react-bootstrap";
import _ from "lodash";
import { renderFormFields } from "../form/FormRenderer";
import { FormLabelStyle } from "../form/FormLabel";
import { Select, MenuItem } from "@material-ui/core";
import { StyledBlueButton, StyledBlackButton } from "../../styles/BootstrapStyles";
import RequestUtils from "../../utils/RequestUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import { RequestContext } from "../../context/RequestContext";
import JobUtils from "../../utils/JobsUtils";
import "../../styles/form.scss";

const CONSTANTS = {
  DELIVERY_OPTION: "deliveryOption",
};

const optionsToTypeMapping = {
  "Aspera AoC": "Aspera AoC Accounts",
  "Aspera Faspex": "Aspera AoC Accounts",
  "Aspera P2P": "Aspera P2P Accounts",
  "Screeners.com": "Screeners.com Subdomains"
};

const DeliveryForm = () => {
  const deliveryType = ConfigUtils.getDeliveryTypes();
  const {
    jobType,
    showDeliveryForm,
    _setShowDeliveryForm,
    _setSelectedDelivery,
    selectedDelivery,
    deliveriesToSourceMapping,
    _setDeliveriesToSourceMapping,
    addNewDelivery,
    itemList,
    getItemList,
    sourceLocation,
    deliveryMetadataKey,
    _setDeliveryMetadataKey
  } = useContext(RequestContext);
  const [deliveryOption, setDeliveryOption] = useState("");
  const [additionalFields, setAdditionalFields] = useState([]);
  const duplicateRef = useRef(null);
  const [delivery, setDelivery] = useState({});
  const [deliveryFields, setDeliveryFields] = useState([]);
  
  const fetchItemList = (deliveryOptionList) => {
    if (_.includes(Object.keys(optionsToTypeMapping), deliveryOptionList) && !_.has(itemList, deliveryOptionList)) {
      getItemList(optionsToTypeMapping[deliveryOptionList], false);
    }
  };

  useEffect(() => {
    const allDeliveryMethods = _.get(jobType, "deliveryMethods");
    // Below condition will filter out producerPortal and mediaShuttle delivery for Encoding Services
    const deliveryMethods = (_.includes(allDeliveryMethods, 'producerPortal', '') || _.includes(allDeliveryMethods, 'mediaShuttle', '')) && _.get(sourceLocation, 'type', '') === 'MORPH_ENCODING'
      ? allDeliveryMethods.filter(field => field !== 'producerPortal' && field !== 'mediaShuttle') : allDeliveryMethods;
    let delFields = _.map(deliveryMethods, (method) => {
      return _.find(deliveryType, (type) => {
        return _.get(type, "ref") === method;
      });
    }).filter(field => !field.hideFromUI);
    setDeliveryFields(delFields);
    if (selectedDelivery) {
      setDelivery(selectedDelivery);
      let deliveryOptionObject = _.get(selectedDelivery, CONSTANTS.DELIVERY_OPTION);
      setDeliveryOption(deliveryOptionObject);
      let findLabel = _.find(delFields, (option) => {
        return option.label === deliveryOptionObject || option.ref === deliveryOptionObject;
      });
      fetchItemList(_.get(findLabel, "label"));
      _setSelectedDelivery({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let addF = _.cloneDeep(RequestUtils.getAdditionalDataField(deliveryFields, deliveryOption, delivery, itemList));
    addF = _.filter(addF, (field) => !_.get(field, "hideFromUI"));
    if (!_.isEmpty(delivery)) {
      addF = _.map(addF, (field) => {
        if (deliveryOption === _.get(delivery, "deliveryOption")) {
          field.value = delivery[field.ref];
        }
        return Object.assign({}, field);
      });
    }
    setAdditionalFields(addF);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryOption, itemList]);

  const handleOption = (field, value) => {
    if (field === CONSTANTS.DELIVERY_OPTION && _.has(delivery, CONSTANTS.DELIVERY_OPTION)) {
      _.map(_.keys(delivery), (item) => {
        if (item !== CONSTANTS.DELIVERY_OPTION && item !== "key") {
          delete delivery[item];
        }
      });
    }
    setDelivery({ ...delivery, [field]: value, "s3Destination": "" });
  };
  
  const resetDeliveryMapping = (deliveryObject) => {
    let delKey = _.get(deliveryObject, "key");
    let clonedMapping = { ...deliveriesToSourceMapping };
    let keys = _.keys(clonedMapping);
    _.map(keys, (key) => {
      let mapping = clonedMapping[key];
      let updatedMapping = _.filter(mapping, function (index) {
        return index !== delKey;
      });
      if (_.size(updatedMapping) === 0) {
        delete clonedMapping[key];
      } else {
        clonedMapping[key] = updatedMapping;
      }
    });
    _setDeliveriesToSourceMapping(clonedMapping);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addNewDelivery(delivery);
    _setShowDeliveryForm(false);
  };

  const handleClose = () => {
    _setShowDeliveryForm(false);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    _setShowDeliveryForm(false);
  }

  const handleSaveAndDuplicate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let formData = duplicateRef.current;
    if (!formData.checkValidity()) {
      formData.reportValidity();
      return;
    }
    addNewDelivery(delivery);
    setDelivery(_.omit(delivery, "key"));
  }

  const handleDeliverySelect = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDeliveryOption(e.target.value);
    let findLabel = _.find(deliveryFields, (option) => {
      return option.label === e.target.value || option.ref === e.target.value;
    });
    fetchItemList(_.get(findLabel, "label"));
    // Setting deliver metadata key order
    const keyLabel = _.get(findLabel, "label")
    const keyOrder = _.get(findLabel, "metadata")
    const newDeliveryMetadataKey = {...deliveryMetadataKey, [keyLabel]: ["deliveryOption", ...keyOrder]};
    _setDeliveryMetadataKey(newDeliveryMetadataKey);
    //Resetting delivery mapping once we change delivery option for EVENT_SCREENERS
    if (JobUtils.extractJobTypeProperty(jobType, "jobType") === "EVENT_SCREENERS") {
      resetDeliveryMapping(delivery);
    }
    handleOption("deliveryOption", e.target.value);
  }

  return (
    <Modal
      className="modal"
      backdrop="static"
      show={showDeliveryForm}
      size="lg"
      centered
      dialogClassName="modalDialog"
      onHide={handleClose}>
      <Modal.Header className="modalHeader" closeButton>
        <Modal.Title className="modalHeaderTitle">Add/Edit Delivery</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modalBody">
        <Form
          className="regularFont"
          onSubmit={handleSubmit}
          id="delivery-form"
          ref={duplicateRef}>
          <Form.Group
            className="m-0 p-0"
            key={"group-deliver-options"}
            as={Row}
            controlId={"deliver-options"}>
            <Form.Label className="formLabel">
              {<FormLabelStyle label={"Delivery Option"} impField={true} />}
            </Form.Label>
            <Form.Control
              as={Select}
              className="formInputSelect"
              classes={{
                root: "dropdownRoot"
              }}
              disabled={false}
              required={true}
              disableUnderline={true}
              displayEmpty
              MenuProps={{
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                style: {
                  zIndex: 15000
                }
              }}
              value={_.get(delivery, "deliveryOption", "") || ''}
              onChange={handleDeliverySelect}>
              <MenuItem className="dropdownSelect" value={""}>
                -----
              </MenuItem>
              {_.map(deliveryFields, (item, index) => {
                return (
                  <MenuItem className="dropdownSelect" key={index} value={_.get(item, "label")}>
                    {_.get(item, "label")}
                  </MenuItem>
                );
              })}
            </Form.Control>
          </Form.Group>
          {_.isEmpty(additionalFields)
            ? null
            : renderFormFields(
              additionalFields,
              handleOption,
              delivery,
              setDelivery
            )}
          {true ? (
            <Row style={{
              padding: "30px 15px 30px 15px",
              justifyContent: "right"
            }}>
              <StyledBlueButton
                id={"save-duplicate"}
                onClick={handleSaveAndDuplicate}>
                Save &amp; Duplicate
              </StyledBlueButton>

              <StyledBlueButton
                id={"save"}
                type="submit">
                Save
              </StyledBlueButton>
              <StyledBlackButton
                id={"cancel"}
                onClick={handleCancel}>
                Cancel
              </StyledBlackButton>
            </Row>
          ) : null}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(DeliveryForm);
